export default __webpack_public_path__ + "static/media/landing-page.80158096.png";